/**
 * Types for dbt's MetricFlow semantic layer as it appears in the dbt manifest
 * (`semantic_models` + `metrics`). These are the definitions dbt Core writes
 * when a project uses semantic models — no dbt Cloud required.
 *
 * Translation into Lightdash metrics lives in `dbt/metricFlow.ts`.
 */
/** MetricFlow measure aggregation types (dbt manifest `Measure.agg`). */
export var MetricFlowAggregation;
(function (MetricFlowAggregation) {
    MetricFlowAggregation["SUM"] = "sum";
    MetricFlowAggregation["MIN"] = "min";
    MetricFlowAggregation["MAX"] = "max";
    MetricFlowAggregation["COUNT_DISTINCT"] = "count_distinct";
    MetricFlowAggregation["SUM_BOOLEAN"] = "sum_boolean";
    MetricFlowAggregation["AVERAGE"] = "average";
    MetricFlowAggregation["PERCENTILE"] = "percentile";
    MetricFlowAggregation["MEDIAN"] = "median";
    MetricFlowAggregation["COUNT"] = "count";
})(MetricFlowAggregation || (MetricFlowAggregation = {}));
//# sourceMappingURL=dbtSemanticLayer.js.map